import ApplicationWrapper from "../../../general/ApplicationWrapper";
import Form from "./Form";

const ProfileEdit = () => {
  return (
    <ApplicationWrapper>
      <div className='grid justify-items-center'>
        <Form />
      </div>
    </ApplicationWrapper>
  );
};

export default ProfileEdit;
